import { useState, useRef } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, Chip, ChipAction, List, ListItem, ListSubHeader, Popover, TextInput } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
const MAX_LABEL_LENGTH = 40;
export function AddLabelAutoComplete(props) {
    const { suggestions } = props;
    const [field, , { setValue }] = useField('labels');
    const [activeSuggestion, setActiveSuggestion] = useState(0);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [userInput, setUserInput] = useState('');
    const addButtonRef = useRef(null);
    const onChange = (e) => {
        const newUserInput = e.currentTarget.value;
        const trimmedUserInput = newUserInput.trim();
        const filtered = suggestions
            .filter((suggestion) => suggestion.toLowerCase().includes(trimmedUserInput.toLowerCase()))
            .slice(0, 3);
        setActiveSuggestion(-1);
        setFilteredSuggestions(filtered);
        if (filtered.length > 0) {
            setShowSuggestions(true);
        }
        else {
            setShowSuggestions(false);
        }
        setUserInput(newUserInput);
    };
    const addLabel = (newLabel) => {
        var _a;
        if (!newLabel.length) {
            return;
        }
        const trimmedLabel = newLabel.trim();
        if (newLabel) {
            const currentLabels = (_a = field.value) !== null && _a !== void 0 ? _a : [];
            if (!currentLabels.includes(trimmedLabel)) {
                setValue([...currentLabels, trimmedLabel]);
            }
            setUserInput('');
        }
    };
    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            setShowSuggestions(false);
            addLabel(userInput);
        }
        else if (showSuggestions && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
            e.preventDefault();
            const direction = e.key === 'ArrowDown' ? 1 : -1;
            const newIndex = (activeSuggestion + direction + filteredSuggestions.length) % filteredSuggestions.length;
            setActiveSuggestion(newIndex);
            setUserInput(filteredSuggestions[newIndex]);
        }
    };
    // Delay closing to allow click events to register
    const onBlur = () => {
        setTimeout(() => setShowSuggestions(false), 100);
    };
    const onFocus = () => {
        if (filteredSuggestions.length > 0) {
            setShowSuggestions(true);
        }
    };
    const displaySuggestionsList = Boolean(showSuggestions && userInput && filteredSuggestions.length > 0);
    const displayCreateLabelButton = userInput.trim() && !showSuggestions && suggestions.indexOf(userInput.trim()) === -1;
    return (<Box flexDirection="column" gap="md">
      <Popover padding="sm" open={displaySuggestionsList} onClose={() => setShowSuggestions(false)} target={<div>
            <TextInput label={t({
                message: 'Add label',
                comment: 'Prompt library - Label for label input when editing a prompt',
            })} type="text" onChange={onChange} onKeyDown={onKeyDown} onBlur={onBlur} onFocus={onFocus} value={userInput} autoComplete="off" maxLength={MAX_LABEL_LENGTH} placeholder={t({
                message: 'Add label',
                comment: 'Prompt library - Placeholder for label input when editing a prompt',
            })} adornmentRight={displayCreateLabelButton && (<Button type="button" appearance="secondary" size="xs" onClick={() => addLabel(userInput)} ref={addButtonRef}>
                    <Falcon icon="plus"/>
                    <Trans comment="Prompt library - Button to add a label to a prompt when editing">Add</Trans>
                  </Button>)} stretch/>
          </div>}>
        <List>
          <ListSubHeader>
            <Trans comment="Prompt library - Suggestion list header when editing a prompt">Suggestions</Trans>
          </ListSubHeader>
          {filteredSuggestions.map((suggestion, index) => (<ListItem key={suggestion} selected={index === activeSuggestion} onClick={() => addLabel(suggestion)}>
              {suggestion}
            </ListItem>))}
        </List>
      </Popover>

      {field.value.length > 0 && (<Box gap="md" style={{ flexWrap: 'wrap' }}>
          {field.value.map((label) => (<Chip key={label} icon={<Falcon icon="dot-circle"/>} label={label} action={<ChipAction type="button" onClick={() => {
                        setValue(field.value.filter((l) => l !== label));
                    }}>
                  <Falcon icon="remove"/>
                </ChipAction>}/>))}
        </Box>)}
    </Box>);
}
